import { ItemsNotificationType } from 'data/interfaces/INotification';
import { ITelegramNotification } from 'data/interfaces/ITelegramNotification';
import request from 'utils/request';

export default class NotificationRepository {
  static async getUnreadStats(): Promise<{
    items: { type: ItemsNotificationType; count: number }[];
    total: number;
  } | null> {
    const res = await request({
      method: 'get',
      url: '/api/notification/unread-stat',
    });
    if (res.err) {
      return null;
    }
    return res;
  }

  static async getNotifyList(
    data: { types?: ItemsNotificationType; lastCreatedAt?: string },
    page?: number,
    limit?: number,
  ): Promise<any | null> {
    const res = await request({
      method: 'get',
      url: '/api/notification',
      data: {
        page: page || 1,
        limit: limit || 10,
        ...data,
      },
    });
    if (res.err) {
      return null;
    }
    return res;
  }

  static async getNotificationProviders(token?: string): Promise<ITelegramNotification[] | null> {
    const res = await request({
      method: 'get',
      url: '/api/notification/provider',
      token,
    });

    if (res.err) {
      return null;
    }

    return res;
  }

  static async generateTelegramBotUrl(): Promise<{ botUrl: string; code: string } | null> {
    const res = await request({
      method: 'post',
      url: '/api/notification/provider/generate',
    });

    if (res.err) {
      return null;
    }

    return res;
  }

  static async registerPushToken(token?: string) {
    const res = await request({
      url: '/api/auth/session/push/',
      method: 'post',
      data: { token },
    });

    if (res.err) {
      return null;
    }

    return res;
  }
}
